const ESTIMATE_CONSTANT = {
  基板の種類: {
    リジッド基板: {
      name: "リジッド基板",
      value: "1",
    },
    フレキシブル基板: {
      name: "フレキシブル基板",
      value: "4",
    },
    メタル放熱基板: {
      name: "メタル放熱基板",
      value: "5",
    },
  },
  部品調達: {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "2",
    },
  },
  メタル材質: {
    アルミ: {
      name: "アルミ",
      value: "204C100000",
    },
    銅: {
      name: "銅",
      value: "204C100001",
    },
  },
  構成層数: {
    片面: {
      name: "片面",
      value: "3",
    },
    "2層": {
      name: "2層",
      value: "1",
    },
    "4層": {
      name: "4層",
      value: "2",
    },
    "6層": {
      name: "6層",
      value: "4",
    },
    "8層": {
      name: "8層",
      value: "5",
    },
    "10層": {
      name: "10層",
      value: "10",
    },
    "12層": {
      name: "12層",
      value: "11",
    },
    FPC片面: {
      name: "FPC片面",
      value: "6",
    },
    FPC2層両面: {
      name: "FPC2層両面",
      value: "7",
    },
    FPC3層: {
      name: "FPC3層",
      value: "19",
    },
    FPC4層: {
      name: "FPC4層",
      value: "20",
    },
    片面アルミベース: {
      name: "片面アルミベース",
      value: "8",
    },
    "2層アルミベース": {
      name: "2層アルミベース",
      value: "9",
    },
    "2層アルミコア": {
      name: "2層アルミコア",
      value: "12",
    },
    片面銅ベース: {
      name: "片面銅ベース",
      value: "13",
    },
    "2層銅ベース": {
      name: "2層銅ベース",
      value: "14",
    },
    "2層銅コア": {
      name: "2層銅コア",
      value: "15",
    },
    片面銅ベースポスト: {
      name: "片面銅ベースポスト",
      value: "16",
    },
    "2層銅ベースポスト": {
      name: "2層銅ベースポスト",
      value: "17",
    },
    "2層銅コアポスト": {
      name: "2層銅コアポスト",
      value: "18",
    },
  },
  パターン面: {
    L1面視のL2面: {
      name: "L1面視のL2面",
      value: "2047200000",
    },
    L1面視のL1面: {
      name: "L1面視のL1面",
      value: "2047200001",
    },
    L2面視のL1面: {
      name: "L2面視のL1面",
      value: "2047200002",
    },
    L2面視のL2面: {
      name: "L2面視のL2面",
      value: "2047200003",
    },
  },
  矩形形状: {
    はい: {
      name: "はい",
      value: "2048100000",
    },
    いいえ: {
      name: "いいえ",
      value: "2048100001",
    },
  },
  CAD選択: {
    CAD指定なし: {
      name: "CAD指定なし",
      value: "0",
    },
    Altium: {
      name: "Altium",
      value: "8",
    },
    "CADLUS ONE（CADLUS Xで編集可能）": {
      name: "CADLUS ONE（CADLUS Xで編集可能）",
      value: "2",
    },
    "CR5000-BD": {
      name: "CR5000-BD",
      value: "4",
    },
    "CR5000-PWS": {
      name: "CR5000-PWS",
      value: "1",
    },
    KiCad: {
      name: "KiCad",
      value: "10",
    },
    OrCAD: {
      name: "OrCAD",
      value: "11",
    },
    Quadcept: {
      name: "Quadcept",
      value: "6",
    },
  },
  回路図の支給形態: {
    "回路図＋ネットリスト": {
      name: "回路図＋ネットリスト",
      value: "1",
    },
    回路図: {
      name: "回路図",
      value: "2",
    },
  },
  "外形が特殊形状・カードエッジコネクタ": {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  "固有の仕様書・設計指示書": {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  半田種類: {
    共晶半田: {
      name: "共晶半田",
      value: "1",
    },
    鉛フリー半田: {
      name: "鉛フリー半田",
      value: "2",
    },
  },
  "実装面 SMD": {
    部品面: {
      name: "部品面",
      value: "10",
    },
    半田面: {
      name: "半田面",
      value: "01",
    },
    両面: {
      name: "両面",
      value: "11",
    },
  },
  "実装面 DIP": {
    部品面: {
      name: "部品面",
      value: "10",
    },
    半田面: {
      name: "半田面",
      value: "01",
    },
    両面: {
      name: "両面",
      value: "11",
    },
  },
  実装方法: {
    リフロー実装をする: {
      name: "リフロー実装をする",
      value: "0",
    },
    手付実装をする: {
      name: "手付実装をする",
      value: "5",
    },
  },
  マウントデータの支給: {
    なし: {
      name: "なし",
      value: "false",
    },
    あり: {
      name: "あり",
      value: "true",
    },
  },
  "メタルマスクの製造・支給選択": {
    マスク用ガーバーデータから製造する: {
      name: "マスク用ガーバーデータから製造する",
      value: "2",
    },
    "マスク用ガーバーデータが無く、基板ガーバーデータ一式から製造する": {
      name: "マスク用ガーバーデータが無く、基板ガーバーデータ一式から製造する",
      value: "3",
    },
    お客様より支給あり: {
      name: "お客様より支給あり",
      value: "1",
    },
    // GugenHubでメタルマスク在庫を選択した場合に使用する値。
    // バックエンドのMetalMask Enum PBAN("4")に対応する。
    // UIでは選択肢として表示されず、GHメタルマスク選択時に裏で自動セットされる。
    GugenHub在庫: {
      name: "GugenHub在庫",
      value: "4",
    },
  },
  "P板.com無料提供部品": {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  お客様支給部品: {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  材質: {
    "FR-4": {
      name: "FR-4",
      value: "2041000000",
    },
    "高Tg材（Tg180 FR-4）": {
      name: "高Tg材（Tg180 FR-4）",
      value: "2041000001",
    },
    "CEM-3": {
      name: "CEM-3",
      value: "2041000002",
    },
    "ハロゲンフリー材（FR-4）(2層以下)": {
      name: "ハロゲンフリー材（FR-4）",
      value: "2041000003",
    },
    "ハロゲンフリー材（FR-4）(4層)": {
      name: "ハロゲンフリー材（FR-4）",
      value: "2041300001",
    },
    "ハロゲンフリー材（FR-4）(6層)": {
      name: "ハロゲンフリー材（FR-4）",
      value: "2041400001",
    },
    "ハロゲンフリー材（FR-4）(8層以上)": {
      name: "ハロゲンフリー材（FR-4）",
      value: "2041500001",
    },
    "FR-1": {
      name: "FR-1",
      value: "2041000004",
    },
    "パナソニック材（R1705相当品FR-4）": {
      name: "パナソニック材（R1705相当品FR-4）",
      value: "2041000005",
    },
    "耐トラッキング材（CTI600 FR-4）": {
      name: "耐トラッキング材（CTI600 FR-4）",
      value: "2041000006",
    },
    "Rogers材（4350B）": {
      name: "Rogers材（4350B）",
      value: "2041000007",
    },
    "パナソニック材（MEGTRON6）": {
      name: "パナソニック材（MEGTRON6）",
      value: "2041000008",
    },
    "銅箔＋接着層＋PI（ポリイミド）": {
      name: "銅箔＋接着層＋PI（ポリイミド）",
      value: "204B400000",
    },
    "銅箔＋PI（ポリイミド）": {
      name: "銅箔＋PI（ポリイミド）",
      value: "204B400001",
    },
  },
  板厚: {
    "0.15mm": {
      name: "0.15mm",
      value: "2040600011",
    },
    "0.2mm": {
      name: "0.2mm",
      value: "2040600012",
    },
    "0.3mm": {
      name: "0.3mm",
      value: "2040600013",
    },
    "0.4mm": {
      name: "0.4mm",
      value: "2040600007",
    },
    "0.6mm": {
      name: "0.6mm",
      value: "2040600008",
    },
    "0.8mm": {
      name: "0.8mm",
      value: "2040600001",
    },
    "1.0mm": {
      name: "1.0mm",
      value: "2040600002",
    },
    "1.2mm": {
      name: "1.2mm",
      value: "2040600003",
    },
    "1.6mm": {
      name: "1.6mm",
      value: "2040600000",
    },
    "1.8mm": {
      name: "1.8mm",
      value: "2040600005",
    },
    "2.0mm": {
      name: "2.0mm",
      value: "2040600006",
    },
    "2.4mm": {
      name: "2.4mm",
      value: "2040600009",
    },
    "3.0mm": {
      name: "3.0mm",
      value: "2040600010",
    },
    "0.25mm（Rogers材）": {
      name: "0.25mm（Rogers材）",
      value: "2040600014",
    },
    "0.5mm（Rogers材）": {
      name: "0.5mm（Rogers材）",
      value: "2040600015",
    },
    "0.76mm（Rogers材）": {
      name: "0.76mm（Rogers材）",
      value: "2040600016",
    },
  },
  ベース材厚: {
    "12.5μm(0.1mm以上__片面)": {
      name: "12.5μm",
      value: "2041900001",
    },
    "12.5μm(0.1mm以上__2層)": {
      name: "12.5μm",
      value: "2042000000",
    },
    "12.5μm(0.1mm未満)": {
      name: "12.5μm",
      value: "2048400000",
    },
    "12.5μm(3層)": {
      name: "12.5μm",
      value: "204C900000",
    },
    "12.5μm(4層)": {
      name: "12.5μm",
      value: "204D000000",
    },
    "25μm(0.1mm以上__片面)": {
      name: "25μm",
      value: "2041900000",
    },
    "25μm(0.1mm以上__2層)": {
      name: "25μm",
      value: "2042000001",
    },
    "25μm(0.1mm未満)": {
      name: "25μm",
      value: "2048400002",
    },
  },
  "ベース／コアの厚み": {
    "0.8mm": {
      name: "0.8mm",
      value: "2046200001",
    },
    "1.5mm": {
      name: "1.5mm",
      value: "2046200000",
    },
    "1.0mm": {
      name: "1.0mm",
      value: "2046200002",
    },
    "2.0mm": {
      name: "2.0mm",
      value: "2046200003",
    },
  },
  銅箔厚み: {
    "18μm(リジッド)": {
      name: "18μm",
      value: "2040700001",
    },
    "18μm(フレキシブル__0.1mm未満)": {
      name: "18μm",
      value: "2048500002",
    },
    "18μm(フレキシブル__0.1mm以上__2層)": {
      name: "18μm",
      value: "2042200000",
    },
    "18μm(フレキシブル__0.1mm以上__片面)": {
      name: "18μm",
      value: "2042100001",
    },
    "35μm(リジッド)": {
      name: "35μm",
      value: "2040700000",
    },
    "35μm(フレキシブル__片面)": {
      name: "35μm",
      value: "2042100000",
    },
    "35μm(フレキシブル__2層)": {
      name: "35μm",
      value: "2042200001",
    },
    "35μm(メタル)": {
      name: "35μm",
      value: "2047000000",
    },
    "70μm(リジッド)": {
      name: "70μm",
      value: "2040700002",
    },
    "70μm(メタル)": {
      name: "70μm",
      value: "2047000001",
    },
    "105μm": {
      name: "105μm",
      value: "2040700003",
    },
    "140μm": {
      name: "140μm",
      value: "2040700004",
    },
    "175μm": {
      name: "175μm",
      value: "2040700005",
    },
    内層35μm外層18μm: {
      name: "内層35μm外層18μm",
      value: "2040800000",
    },
    内層35μm外層35μm: {
      name: "内層35μm外層35μm",
      value: "2040800001",
    },
    内層35μm外層70μm: {
      name: "内層35μm外層70μm",
      value: "2040800002",
    },
    内層70μm外層70μm: {
      name: "内層70μm外層70μm",
      value: "2040800003",
    },
    "内層18μm外層18μm(リジッド)": {
      name: "内層18μm外層18μm",
      value: "2040800004",
    },
    "内層18μm外層18μm(フレキシブル)": {
      name: "内層18μm外層18μm",
      value: "204D100000",
    },
    内層18μm外層35μm: {
      name: "内層18μm外層35μm",
      value: "2040800005",
    },
    内層18μm外層70μm: {
      name: "内層18μm外層70μm",
      value: "2040800006",
    },
    内層70μm外層18μm: {
      name: "内層70μm外層18μm",
      value: "2040800007",
    },
    内層70μm外層35μm: {
      name: "内層70μm外層35μm",
      value: "2040800008",
    },
    "9μm": {
      name: "9μm",
      value: "2048500001",
    },
    "12μm": {
      name: "12μm",
      value: "2048500000",
    },
    "内層12.5μm外層12.5μm": {
      name: "内層12.5μm外層12.5μm",
      value: "204D100001",
    },
  },
  ビルドアップ工法: {
    "なし(片面2層)": {
      name: "なし",
      value: "204A000000",
    },
    "なし(4層)": {
      name: "なし",
      value: "204A100000",
    },
    "なし(6層)": {
      name: "なし",
      value: "204A200000",
    },
    "なし(8層)": {
      name: "なし",
      value: "204A300000",
    },
    "なし(10層)": {
      name: "なし",
      value: "204A400000",
    },
    "なし(12層)": {
      name: "なし",
      value: "204A500000",
    },
    "1-2-1 BHなし": {
      name: "1-2-1 BHなし",
      value: "204A100001",
    },
    "1-2-1 BHあり スタガード": {
      name: "1-2-1 BHあり スタガード",
      value: "204A100002",
    },
    "1-2-1 BHあり スタック": {
      name: "1-2-1 BHあり スタック",
      value: "204A100003",
    },
    "その他の構成(4層)": {
      name: "その他の構成",
      value: "204A100099",
    },
    "その他の構成(6層)": {
      name: "その他の構成",
      value: "204A200099",
    },
    "その他の構成(8層)": {
      name: "その他の構成",
      value: "204A300099",
    },
    "その他の構成(10層)": {
      name: "その他の構成",
      value: "204A400099",
    },
    "その他の構成(12層)": {
      name: "その他の構成",
      value: "204A500099",
    },
    "1-4-1 BHなし": {
      name: "1-4-1 BHなし",
      value: "204A200001",
    },
    "1-4-1 BHあり": {
      name: "1-4-1 BHあり",
      value: "204A200002",
    },
    "2-2-2 BHなし": {
      name: "2-2-2 BHなし",
      value: "204A200003",
    },
    "2-2-2 スタック": {
      name: "2-2-2 スタック",
      value: "204A200004",
    },
    "2-2-2 BHあり スタガード": {
      name: "2-2-2 BHあり スタガード",
      value: "204A200005",
    },
    "2-2-2 BHあり フルスタック": {
      name: "2-2-2 BHあり フルスタック",
      value: "204A200006",
    },
    "1-6-1 BHなし": {
      name: "1-6-1 BHなし",
      value: "204A300001",
    },
    "2-4-2 BHなし": {
      name: "2-4-2 BHなし",
      value: "204A300002",
    },
    "2-4-2 BHなし スタック": {
      name: "2-4-2 BHなし スタック",
      value: "204A300003",
    },
    "2-4-2 BHあり スタガード": {
      name: "2-4-2 BHあり スタガード",
      value: "204A300004",
    },
    "2-4-2 BHあり フルスタック": {
      name: "2-4-2 BHあり フルスタック",
      value: "204A300005",
    },
    "3-2-3 BHなし スタガード": {
      name: "3-2-3 BHなし スタガード",
      value: "204A300006",
    },
    "3-2-3 BHなし スタック": {
      name: "3-2-3 BHなし スタック",
      value: "204A300007",
    },
    "3-2-3 BHあり フルスタック": {
      name: "3-2-3 BHあり フルスタック",
      value: "204A300008",
    },
    "1-8-1": {
      name: "1-8-1",
      value: "204A400001",
    },
    "2-6-2": {
      name: "2-6-2",
      value: "204A400002",
    },
    "3-4-3": {
      name: "3-4-3",
      value: "204A400003",
    },
    "1-10-1": {
      name: "1-10-1",
      value: "204A500001",
    },
    "2-8-2": {
      name: "2-8-2",
      value: "204A500002",
    },
    "3-6-3": {
      name: "3-6-3",
      value: "204A500003",
    },
    "4-4-4": {
      name: "4-4-4",
      value: "204A500004",
    },
  },
  "最小パターン幅／間隔": {
    "0.030mm": {
      name: "0.030mm",
      value: "2041600009",
    },
    "0.050mm": {
      name: "0.050mm",
      value: "2041600008",
    },
    "0.060mm": {
      name: "0.060mm",
      value: "2041600007",
    },
    "0.075mm": {
      name: "0.075mm",
      value: "2041600003",
    },
    "0.10mm": {
      name: "0.10mm",
      value: "2041600002",
    },
    "0.127mm": {
      name: "0.127mm",
      value: "2041600000",
    },
    "0.15mm": {
      name: "0.15mm",
      value: "2041600001",
    },
    "0.20mm": {
      name: "0.20mm",
      value: "2041600010",
    },
    "0.25mm": {
      name: "0.25mm",
      value: "2041600004",
    },
    "0.30mm": {
      name: "0.30mm",
      value: "2041600005",
    },
    "0.35mm": {
      name: "0.35mm",
      value: "2041600006",
    },
    "0.40mm": {
      name: "0.40mm",
      value: "2041600011",
    },
  },
  "最小ビア径／ランド径": {
    "φ0.15/0.35mm": {
      name: "φ0.15/0.35mm",
      value: "2042600006",
    },
    "φ0.15/0.4mm": {
      name: "φ0.15/0.4mm",
      value: "2042600005",
    },
    "φ0.2/0.45mm": {
      name: "φ0.2/0.45mm",
      value: "2042600004",
    },
    "φ0.2/0.5mm(リジッド)": {
      name: "φ0.2/0.5mm",
      value: "2042600003",
    },
    "φ0.2/0.5mm(フレキシブル)": {
      name: "φ0.2/0.5mm",
      value: "2049600002",
    },
    "φ0.25/0.5mm(リジッド)": {
      name: "φ0.25/0.5mm",
      value: "2042600002",
    },
    "φ0.25/0.5mm(フレキシブル)": {
      name: "φ0.25/0.5mm",
      value: "2049600001",
    },
    "φ0.3/0.5mm": {
      name: "φ0.3/0.5mm",
      value: "2042600001",
    },
    "φ0.3/0.6mm(リジッド)": {
      name: "φ0.3/0.6mm",
      value: "2042600000",
    },
    "φ0.3/0.6mm(フレキシブル)": {
      name: "φ0.3/0.6mm",
      value: "2049600000",
    },
    "φ0.3/0.6mm(メタル)": {
      name: "φ0.3/0.6mm",
      value: "2046700000",
    },
    "φ0.4/0.8mm": {
      name: "φ0.4/0.8mm",
      value: "2042600007",
    },
    "φ0.5/1.0mm": {
      name: "φ0.5/1.0mm",
      value: "2042600008",
    },
    "φ0.5/1.3mm": {
      name: "φ0.5/1.3mm",
      value: "2042600009",
    },
    "φ0.5/1.5mm": {
      name: "φ0.5/1.5mm",
      value: "2042600010",
    },
    "φ0.15/0.3mm": {
      name: "φ0.15/0.3mm",
      value: "2049600003",
    },
    "φ0.12/0.27mm": {
      name: "φ0.12/0.27mm",
      value: "2049600004",
    },
  },
  "レーザービア径／ランド径": {
    "φ0.1/0.3mm": {
      name: "φ0.1/0.3mm",
      value: "204C000000",
    },
    "φ0.1/0.275mm": {
      name: "φ0.1/0.275mm",
      value: "204C000001",
    },
    "φ0.1/0.25mm": {
      name: "φ0.1/0.25mm",
      value: "204C000002",
    },
    "φ0.08/0.23mm": {
      name: "φ0.08/0.23mm",
      value: "204C000003",
    },
  },
  "配置／配線（配線幅・配線長・シールド）ルール": {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  "高電流（10A以上）高電圧（50V以上）多電源（4種以上）": {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  "BGA／CSP": {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  "シルク追加10個以上（部品番号・ピン番除く）": {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  特性インピーダンスコントロール: {
    なし: {
      name: "なし",
      value: "2041200000",
    },
    "差動（2種、最小75Ωまで）": {
      name: "差動（2種、最小75Ωまで）",
      value: "2041200001",
    },
    "シングルエンド（2種）": {
      name: "シングルエンド（2種）",
      value: "2041200002",
    },
    "シングルエンド（1種）+ 差動（1種、最小75Ωまで）": {
      name: "シングルエンド（1種）+ 差動（1種、最小75Ωまで）",
      value: "2041200003",
    },
  },
  塗布する面: {
    両面に塗る: {
      name: "両面に塗る",
      value: "1",
    },
    "パターン面と同じ面に塗る(L1面に塗る)": {
      name: "パターン面と同じ面に塗る(L1面に塗る)",
      value: "2",
    },
    "パターン面とは逆の面に塗る(Ln面に塗る)": {
      name: "パターン面とは逆の面に塗る(Ln面に塗る)",
      value: "3",
    },
    塗らない: {
      name: "塗らない",
      value: "4",
    },
  },
  レジスト色: {
    "緑(リジッド)": {
      name: "緑",
      value: "2040500000",
    },
    "緑(メタル)": {
      name: "緑",
      value: "2046800001",
    },
    "赤(リジッド)": {
      name: "赤",
      value: "2040500001",
    },
    "赤(メタル)": {
      name: "赤",
      value: "2046800002",
    },
    "青(リジッド)": {
      name: "青",
      value: "2040500002",
    },
    "青(メタル)": {
      name: "青",
      value: "2046800003",
    },
    "黄(リジッド)": {
      name: "黄",
      value: "2040500003",
    },
    "黄(メタル)": {
      name: "黄",
      value: "2046800004",
    },
    "白(リジッド)": {
      name: "白",
      value: "2040500004",
    },
    "白(メタル)": {
      name: "白",
      value: "2046800000",
    },
    "黒(リジッド)": {
      name: "黒",
      value: "2040500005",
    },
    "黒(メタル)": {
      name: "黒",
      value: "2046800005",
    },
    "黒（つや消し）(リジッド)": {
      name: "黒（つや消し）",
      value: "2040500006",
    },
    "黒（つや消し）(メタル)": {
      name: "黒（つや消し）",
      value: "2046800006",
    },
    紫: {
      name: "紫",
      value: "2040500007",
    },
  },
  貼る面: {
    両面貼る: {
      name: "両面貼る",
      value: "1",
    },
    "パターン面と同じ面を貼る(L1面を貼る)": {
      name: "パターン面と同じ面を貼る(L1面を貼る)",
      value: "2",
    },
    "パターン面とは逆の面を貼る(Ln面を貼る)": {
      name: "パターン面とは逆の面を貼る(Ln面を貼る)",
      value: "3",
    },
    貼らない: {
      name: "貼らない",
      value: "4",
    },
  },
  カバーレイ: {
    "12.5μm": {
      name: "12.5μm",
      value: "2042400001",
    },
    "25μm": {
      name: "25μm",
      value: "2042400000",
    },
    グリーンレジスト: {
      name: "グリーンレジスト",
      value: "2042400002",
    },
  },
  カバーレイ色: {
    標準色: {
      name: "標準色",
      value: "204B600000",
    },
    白色: {
      name: "白色",
      value: "204B600001",
    },
    黒色: {
      name: "黒色",
      value: "204B600002",
    },
  },
  印刷する面: {
    なし: {
      name: "なし",
      value: "2046000001",
    },
    "パターン面と同じ面(L1面)": {
      name: "パターン面と同じ面(L1面)",
      value: "2046000002",
    },
    両面: {
      name: "両面",
      value: "2046000003",
    },
    "パターン面とは逆の面(Ln面)": {
      name: "パターン面とは逆の面(Ln面)",
      value: "2046000004",
    },
  },
  シルク印刷色: {
    "白(リジッド)": {
      name: "白",
      value: "2040900000",
    },
    "白(メタル)": {
      name: "白",
      value: "2046900001",
    },
    "白(フレキシブル)": {
      name: "白",
      value: "2049100000",
    },
    "黒(リジッド)": {
      name: "黒",
      value: "2040900001",
    },
    "黒(メタル)": {
      name: "黒",
      value: "2046900000",
    },
    "黒(フレキシブル)": {
      name: "黒",
      value: "2049100001",
    },
    "黄(リジッド)": {
      name: "黄",
      value: "2040900002",
    },
    "黄(メタル)": {
      name: "黄",
      value: "2046900002",
    },
  },
  シルク印刷工法: {
    お任せ: {
      name: "お任せ",
      value: "2049300000",
    },
    写真法: {
      name: "写真法",
      value: "2049300001",
    },
  },
  表面処理: {
    "有鉛はんだレベラー(リジッド)": {
      name: "有鉛はんだレベラー",
      value: "2040400000",
    },
    "有鉛はんだレベラー(メタル)": {
      name: "有鉛はんだレベラー",
      value: "2046100000",
    },
    "端子部のみ電解金めっき＋有鉛はんだレベラー": {
      name: "端子部のみ電解金めっき＋有鉛はんだレベラー",
      value: "2040400001",
    },
    "無電解金フラッシュ(リジッド)": {
      name: "無電解金フラッシュ",
      value: "2040400002",
    },
    "無電解金フラッシュ(フレキシブル)": {
      name: "無電解金フラッシュ",
      value: "2041800002",
    },
    "無電解金フラッシュ(メタル)": {
      name: "無電解金フラッシュ",
      value: "2046100003",
    },
    "水溶性フラックス(リジッド)": {
      name: "水溶性フラックス",
      value: "2040400003",
    },
    "水溶性フラックス(メタル)": {
      name: "水溶性フラックス",
      value: "2046100002",
    },
    "無鉛はんだレベラー(リジッド)": {
      name: "無鉛はんだレベラー",
      value: "2040400005",
    },
    "無鉛はんだレベラー(メタル)": {
      name: "無鉛はんだレベラー",
      value: "2046100001",
    },
    "端子部のみ電解金めっき＋水溶性フラックス": {
      name: "端子部のみ電解金めっき＋水溶性フラックス",
      value: "2040400006",
    },
    "端子部のみ電解金めっき＋無鉛はんだレベラー": {
      name: "端子部のみ電解金めっき＋無鉛はんだレベラー",
      value: "2040400007",
    },
    "しない（銅箔のみ）(リジッド)": {
      name: "しない（銅箔のみ）",
      value: "2040400009",
    },
    "しない（銅箔のみ）(フレキシブル)": {
      name: "しない（銅箔のみ）",
      value: "2041800003",
    },
    リード無し電解金めっき: {
      name: "リード無し電解金めっき",
      value: "2040400010",
    },
    ワイヤーボンディング向け無電解ニッケルパラジウム金めっき: {
      name: "ワイヤーボンディング向け無電解ニッケルパラジウム金めっき",
      value: "2040400012",
    },
    ワイヤーボンディング向け無電解ニッケル金めっき: {
      name: "ワイヤーボンディング向け無電解ニッケル金めっき",
      value: "2040400013",
    },
    錫めっき: {
      name: "錫めっき",
      value: "2041800000",
    },
    "電解金めっき＋水溶性フラックス": {
      name: "電解金めっき＋水溶性フラックス",
      value: "2041800004",
    },
    ニッケルパラジウム金めっき: {
      name: "ニッケルパラジウム金めっき",
      value: "2046100005",
    },
    ワイヤーボンディング向け金めっき: {
      name: "ワイヤーボンディング向け金めっき",
      value: "2046100006",
    },
  },
  端子部のみ電解金めっき: {
    する: {
      name: "する",
      value: "1",
    },
    しない: {
      name: "しない",
      value: "0",
    },
  },
  端子部の面取り加工: {
    しない: {
      name: "しない",
      value: "2049200000",
    },
    角度指定無し: {
      name: "角度指定無し",
      value: "2049200001",
    },
    "角度：45度 深さ：0.5mm": {
      name: "角度：45度 深さ：0.5mm",
      value: "2049200002",
    },
    "角度：30度 深さ：1.0mm": {
      name: "角度：30度 深さ：1.0mm",
      value: "2049200003",
    },
    "角度：20度 深さ：1.8mm": {
      name: "角度：20度 深さ：1.8mm",
      value: "2049200004",
    },
  },
  端子部厚み指定: {
    なし: {
      name: "なし",
      value: "0",
    },
    "1箇所": {
      name: "1箇所",
      value: "1",
    },
    "2箇所": {
      name: "2箇所",
      value: "2",
    },
    "3箇所以上": {
      name: "3箇所以上",
      value: "3",
    },
  },
  仕上り厚み指定: {
    "0.2±0.03mm": {
      name: "0.2±0.03mm",
      value: "204A600001",
    },
    "0.3±0.03mm": {
      name: "0.3±0.03mm",
      value: "204A600002",
    },
    "0.12±0.02mm": {
      name: "0.12±0.02mm",
      value: "204A600003",
    },
    "0.15±0.03mm": {
      name: "0.15±0.03mm",
      value: "204A600004",
    },
    "0.18±0.05mm": {
      name: "0.18±0.05mm",
      value: "204A600005",
    },
  },
  接着面: {
    "パターン面と同じ面(L1面)(片面)": {
      name: "パターン面と同じ面(L1面)",
      value: "204A800002",
    },
    "パターン面と同じ面(L1面)(2層)": {
      name: "パターン面と同じ面(L1面)",
      value: "204A900001",
    },
    "パターン面と同じ面(L1面)(3層)": {
      name: "パターン面と同じ面(L1面)",
      value: "204C700001",
    },
    "パターン面と同じ面(L1面)(4層)": {
      name: "パターン面と同じ面(L1面)",
      value: "204C800001",
    },
    "パターン面とは逆の面(Ln面)(片面)": {
      name: "パターン面とは逆の面(Ln面)",
      value: "204A800001",
    },
    "パターン面とは逆の面(Ln面)(2層)": {
      name: "パターン面とは逆の面(Ln面)",
      value: "204A900002",
    },
    "パターン面とは逆の面(Ln面)(3層)": {
      name: "パターン面とは逆の面(Ln面)",
      value: "204C700002",
    },
    "パターン面とは逆の面(Ln面)(4層)": {
      name: "パターン面とは逆の面(Ln面)",
      value: "204C800002",
    },
  },
  補強板厚み指定: {
    なし: {
      name: "なし",
      value: "0",
    },
    "1箇所": {
      name: "1箇所",
      value: "1",
    },
    "2箇所": {
      name: "2箇所",
      value: "2",
    },
    "3箇所以上": {
      name: "3箇所以上",
      value: "3",
    },
  },
  厚み指定: {
    "0.1mmPI": {
      name: "0.1mmPI",
      value: "204A700001",
    },
    "0.15mmPI": {
      name: "0.15mmPI",
      value: "204A700002",
    },
    "0.2mmPI": {
      name: "0.2mmPI",
      value: "204A700003",
    },
    "0.25mmPI": {
      name: "0.25mmPI",
      value: "204A700004",
    },
    "0.2mmFR-4": {
      name: "0.2mmFR-4",
      value: "204A700005",
    },
    "0.4mmFR-4": {
      name: "0.4mmFR-4",
      value: "204A700006",
    },
    "1.0mmFR-4": {
      name: "1.0mmFR-4",
      value: "204A700007",
    },
    "1.6mmFR-4": {
      name: "1.6mmFR-4",
      value: "204A700008",
    },
    ステンレス: {
      name: "ステンレス",
      value: "204A700009",
    },
  },
  FPC面付けされたデータ: {
    なし: {
      name: "なし",
      value: "2042800000",
    },
    "2面付け": {
      name: "2面付け",
      value: "2042800002",
    },
    "3面付け": {
      name: "3面付け",
      value: "2042800003",
    },
    "4面付け": {
      name: "4面付け",
      value: "2042800004",
    },
    "5面付け": {
      name: "5面付け",
      value: "2042800005",
    },
    "6面付け": {
      name: "6面付け",
      value: "2042800006",
    },
    "7面付け": {
      name: "7面付け",
      value: "2042800007",
    },
    "8面付け": {
      name: "8面付け",
      value: "2042800008",
    },
    "9面付け": {
      name: "9面付け",
      value: "2042800009",
    },
    "10面付け": {
      name: "10面付け",
      value: "2042800010",
    },
    "11面付け": {
      name: "11面付け",
      value: "2042800011",
    },
    "12面付け": {
      name: "12面付け",
      value: "2042800012",
    },
    "13面付け": {
      name: "13面付け",
      value: "2042800013",
    },
    "14面付け": {
      name: "14面付け",
      value: "2042800014",
    },
    "15面付け": {
      name: "15面付け",
      value: "2042800015",
    },
    "16面付け": {
      name: "16面付け",
      value: "2042800016",
    },
    "17面付け": {
      name: "17面付け",
      value: "2042800017",
    },
    "18面付け": {
      name: "18面付け",
      value: "2042800018",
    },
    "19面付け": {
      name: "19面付け",
      value: "2042800019",
    },
    "20面付け": {
      name: "20面付け",
      value: "2042800020",
    },
  },
  "ルーター切り出し面付け 面付け数": {
    なし: {
      name: "なし",
      value: "2040300000",
    },
    "2面付": {
      name: "2面付",
      value: "2040300010",
    },
    "3面付": {
      name: "3面付",
      value: "2040300011",
    },
    "4面付": {
      name: "4面付",
      value: "2040300012",
    },
    "5面付": {
      name: "5面付",
      value: "2040300013",
    },
    "6面付": {
      name: "6面付",
      value: "2040300014",
    },
    "7面付": {
      name: "7面付",
      value: "2040300015",
    },
    "8面付": {
      name: "8面付",
      value: "2040300016",
    },
    "9面付": {
      name: "9面付",
      value: "2040300017",
    },
    "10面付": {
      name: "10面付",
      value: "2040300018",
    },
    "11面付": {
      name: "11面付",
      value: "2040300019",
    },
    "12面付": {
      name: "12面付",
      value: "2040300020",
    },
    "13面付": {
      name: "13面付",
      value: "2040300021",
    },
    "14面付": {
      name: "14面付",
      value: "2040300022",
    },
    "15面付": {
      name: "15面付",
      value: "2040300023",
    },
    "16面付": {
      name: "16面付",
      value: "2040300024",
    },
    "17面付": {
      name: "17面付",
      value: "2040300025",
    },
    "18面付": {
      name: "18面付",
      value: "2040300026",
    },
    "19面付": {
      name: "19面付",
      value: "2040300027",
    },
    "20面付": {
      name: "20面付",
      value: "2040300028",
    },
    "21面付": {
      name: "21面付",
      value: "2040300029",
    },
    "22面付": {
      name: "22面付",
      value: "2040300030",
    },
    "23面付": {
      name: "23面付",
      value: "2040300031",
    },
    "24面付": {
      name: "24面付",
      value: "2040300032",
    },
    "25面付": {
      name: "25面付",
      value: "2040300033",
    },
    "26面付": {
      name: "26面付",
      value: "2040300034",
    },
    "27面付": {
      name: "27面付",
      value: "2040300035",
    },
    "28面付": {
      name: "28面付",
      value: "2040300036",
    },
    "29面付": {
      name: "29面付",
      value: "2040300037",
    },
    "30面付": {
      name: "30面付",
      value: "2040300038",
    },
  },
  "ミシン目面付け 面付け数": {
    なし: {
      name: "なし",
      value: "2040200000",
    },
    "2～5面付": {
      name: "2～5面付",
      value: "2040200001",
    },
    "6～10面付": {
      name: "6～10面付",
      value: "2040200002",
    },
    "11～15面付": {
      name: "11～15面付",
      value: "2040200003",
    },
    "16～20面付": {
      name: "16～20面付",
      value: "2040200004",
    },
    "21～25面付": {
      name: "21～25面付",
      value: "2040200005",
    },
    "26～30面付": {
      name: "26～30面付",
      value: "2040200006",
    },
    あり: {
      name: "あり",
      value: "2040200007",
    },
  },
  データ面付け編集サービス: {
    なし: {
      name: "なし",
      value: "2041100000",
    },
    "同種面付(リジッド1層)": {
      name: "同種面付",
      value: "2043100001",
    },
    "同種面付(リジッド2層)": {
      name: "同種面付",
      value: "2043200001",
    },
    "同種面付(リジッド4層)": {
      name: "同種面付",
      value: "2043300001",
    },
    "同種面付(リジッド6層)": {
      name: "同種面付",
      value: "2043400001",
    },
    "同種面付(リジッド8層)": {
      name: "同種面付",
      value: "2043500001",
    },
    "同種面付(リジッド10層)": {
      name: "同種面付",
      value: "2048200001",
    },
    "同種面付(リジッド12層)": {
      name: "同種面付",
      value: "2048300001",
    },
    "同種面付(メタル1層)": {
      name: "同種面付",
      value: "2046400001",
    },
    "同種面付(メタル2層)": {
      name: "同種面付",
      value: "2046500001",
    },
    "2種面付(リジッド1層)": {
      name: "2種面付",
      value: "2043100002",
    },
    "2種面付(リジッド2層)": {
      name: "2種面付",
      value: "2043200002",
    },
    "2種面付(リジッド4層)": {
      name: "2種面付",
      value: "2043300002",
    },
    "2種面付(リジッド6層)": {
      name: "2種面付",
      value: "2043400002",
    },
    "2種面付(リジッド8層)": {
      name: "2種面付",
      value: "2043500002",
    },
    "2種面付(リジッド10層)": {
      name: "2種面付",
      value: "2048200002",
    },
    "2種面付(リジッド12層)": {
      name: "2種面付",
      value: "2048300002",
    },
    "2種面付(メタル1層)": {
      name: "2種面付",
      value: "2046400002",
    },
    "2種面付(メタル2層)": {
      name: "2種面付",
      value: "2046500002",
    },
    "3種面付(リジッド1層)": {
      name: "3種面付",
      value: "2043100003",
    },
    "3種面付(リジッド2層)": {
      name: "3種面付",
      value: "2043200003",
    },
    "3種面付(リジッド4層)": {
      name: "3種面付",
      value: "2043300003",
    },
    "3種面付(リジッド6層)": {
      name: "3種面付",
      value: "2043400003",
    },
    "3種面付(リジッド8層)": {
      name: "3種面付",
      value: "2043500003",
    },
    "3種面付(リジッド10層)": {
      name: "3種面付",
      value: "2048200003",
    },
    "3種面付(リジッド12層)": {
      name: "3種面付",
      value: "2048300003",
    },
    "3種面付(メタル1層)": {
      name: "3種面付",
      value: "2046400003",
    },
    "3種面付(メタル2層)": {
      name: "3種面付",
      value: "2046500003",
    },
    "4種面付(リジッド1層)": {
      name: "4種面付",
      value: "2043100004",
    },
    "4種面付(リジッド2層)": {
      name: "4種面付",
      value: "2043200004",
    },
    "4種面付(リジッド4層)": {
      name: "4種面付",
      value: "2043300004",
    },
    "4種面付(リジッド6層)": {
      name: "4種面付",
      value: "2043400004",
    },
    "4種面付(リジッド8層)": {
      name: "4種面付",
      value: "2043500004",
    },
    "4種面付(リジッド10層)": {
      name: "4種面付",
      value: "2048200004",
    },
    "4種面付(リジッド12層)": {
      name: "4種面付",
      value: "2048300004",
    },
    "4種面付(メタル1層)": {
      name: "4種面付",
      value: "2046400004",
    },
    "4種面付(メタル2層)": {
      name: "4種面付",
      value: "2046500004",
    },
    "5種面付(リジッド1層)": {
      name: "5種面付",
      value: "2043100005",
    },
    "5種面付(リジッド2層)": {
      name: "5種面付",
      value: "2043200005",
    },
    "5種面付(リジッド4層)": {
      name: "5種面付",
      value: "2043300005",
    },
    "5種面付(リジッド6層)": {
      name: "5種面付",
      value: "2043400005",
    },
    "5種面付(リジッド8層)": {
      name: "5種面付",
      value: "2043500005",
    },
    "5種面付(リジッド10層)": {
      name: "5種面付",
      value: "2048200005",
    },
    "5種面付(リジッド12層)": {
      name: "5種面付",
      value: "2048300005",
    },
    "5種面付(メタル1層)": {
      name: "5種面付",
      value: "2046400005",
    },
    "5種面付(メタル2層)": {
      name: "5種面付",
      value: "2046500005",
    },
    "6種面付(リジッド1層)": {
      name: "6種面付",
      value: "2043100006",
    },
    "6種面付(リジッド2層)": {
      name: "6種面付",
      value: "2043200006",
    },
    "6種面付(リジッド4層)": {
      name: "6種面付",
      value: "2043300006",
    },
    "6種面付(リジッド6層)": {
      name: "6種面付",
      value: "2043400006",
    },
    "6種面付(リジッド8層)": {
      name: "6種面付",
      value: "2043500006",
    },
    "6種面付(リジッド10層)": {
      name: "6種面付",
      value: "2048200006",
    },
    "6種面付(リジッド12層)": {
      name: "6種面付",
      value: "2048300006",
    },
    "6種面付(メタル1層)": {
      name: "6種面付",
      value: "2046400006",
    },
    "6種面付(メタル2層)": {
      name: "6種面付",
      value: "2046500006",
    },
    "7種面付(リジッド1層)": {
      name: "7種面付",
      value: "2043100007",
    },
    "7種面付(リジッド2層)": {
      name: "7種面付",
      value: "2043200007",
    },
    "7種面付(リジッド4層)": {
      name: "7種面付",
      value: "2043300007",
    },
    "7種面付(リジッド6層)": {
      name: "7種面付",
      value: "2043400007",
    },
    "7種面付(リジッド8層)": {
      name: "7種面付",
      value: "2043500007",
    },
    "7種面付(リジッド10層)": {
      name: "7種面付",
      value: "2048200007",
    },
    "7種面付(リジッド12層)": {
      name: "7種面付",
      value: "2048300007",
    },
    "7種面付(メタル1層)": {
      name: "7種面付",
      value: "2046400007",
    },
    "7種面付(メタル2層)": {
      name: "7種面付",
      value: "2046500007",
    },
    "8種面付(リジッド1層)": {
      name: "8種面付",
      value: "2043100008",
    },
    "8種面付(リジッド2層)": {
      name: "8種面付",
      value: "2043200008",
    },
    "8種面付(リジッド4層)": {
      name: "8種面付",
      value: "2043300008",
    },
    "8種面付(リジッド6層)": {
      name: "8種面付",
      value: "2043400008",
    },
    "8種面付(リジッド8層)": {
      name: "8種面付",
      value: "2043500008",
    },
    "8種面付(リジッド10層)": {
      name: "8種面付",
      value: "2048200008",
    },
    "8種面付(リジッド12層)": {
      name: "8種面付",
      value: "2048300008",
    },
    "8種面付(メタル1層)": {
      name: "8種面付",
      value: "2046400008",
    },
    "8種面付(メタル2層)": {
      name: "8種面付",
      value: "2046500008",
    },
  },
  端面スルーホール: {
    なし: {
      name: "なし",
      value: "2042900000",
    },
    あり: {
      name: "あり",
      value: "2042900001",
    },
  },
  長穴: {
    なし: {
      name: "なし",
      value: "2046600000",
    },
    あり: {
      name: "あり",
      value: "2046600001",
    },
  },
  "パッド・オン・ビア": {
    なし: {
      name: "なし",
      value: "2045900000",
    },
    あり: {
      name: "あり",
      value: "2045900001",
    },
  },
  "0.3mm未満のパッド": {
    なし: {
      name: "なし",
      value: "2049500000",
    },
    あり: {
      name: "あり",
      value: "2049500001",
    },
  },
  電磁波シールド: {
    "貼らない(片面)": {
      name: "貼らない",
      value: "204B700000",
    },
    "貼らない(2層)": {
      name: "貼らない",
      value: "204B800000",
    },
    "貼らない(3層)": {
      name: "貼らない",
      value: "204C500000",
    },
    "貼らない(4層)": {
      name: "貼らない",
      value: "204C600000",
    },
    "パターン面と同じ面を貼る(L1面を貼る)(片面)": {
      name: "パターン面と同じ面を貼る(L1面を貼る)",
      value: "204B700001",
    },
    "パターン面と同じ面を貼る(L1面を貼る)(2層)": {
      name: "パターン面と同じ面を貼る(L1面を貼る)",
      value: "204B800001",
    },
    "パターン面と同じ面を貼る(L1面を貼る)(3層)": {
      name: "パターン面と同じ面を貼る(L1面を貼る)",
      value: "204C500001",
    },
    "パターン面と同じ面を貼る(L1面を貼る)(4層)": {
      name: "パターン面と同じ面を貼る(L1面を貼る)",
      value: "204C600001",
    },
    "パターン面と逆の面を貼る(Ln面を貼る)(片面)": {
      name: "パターン面と逆の面を貼る(Ln面を貼る)",
      value: "204B700002",
    },
    "パターン面と逆の面を貼る(Ln面を貼る)(2層)": {
      name: "パターン面と逆の面を貼る(Ln面を貼る)",
      value: "204B800002",
    },
    "パターン面と逆の面を貼る(Ln面を貼る)(3層)": {
      name: "パターン面と逆の面を貼る(Ln面を貼る)",
      value: "204C500002",
    },
    "パターン面と逆の面を貼る(Ln面を貼る)(4層)": {
      name: "パターン面と逆の面を貼る(Ln面を貼る)",
      value: "204C600002",
    },
    "両面貼る(片面)": {
      name: "両面貼る",
      value: "204B700003",
    },
    "両面貼る(2層)": {
      name: "両面貼る",
      value: "204B800003",
    },
    "両面貼る(3層)": {
      name: "両面貼る",
      value: "204C500003",
    },
    "両面貼る(4層)": {
      name: "両面貼る",
      value: "204C600003",
    },
  },
  ULマーク: {
    なし: {
      name: "なし",
      value: "2041700000",
    },
    位置指定あり: {
      name: "位置指定あり",
      value: "2041700001",
    },
    位置指定なし: {
      name: "位置指定なし",
      value: "2041700002",
    },
  },
  "AOI検査（外観光学検査）": {
    なし: {
      name: "なし",
      value: "2049400000",
    },
    あり: {
      name: "あり",
      value: "2049400001",
    },
  },
  製造検査成績書: {
    発行あり: {
      name: "発行あり",
      value: "1",
    },
    発行なし: {
      name: "発行なし",
      value: "0",
    },
  },
  実装検査成績書: {
    発行あり: {
      name: "発行あり",
      value: "1",
    },
    発行なし: {
      name: "発行なし",
      value: "0",
    },
  },
  データ形式: {
    "ガーバーデータ 又はCADLUS Xデータ（.comp形式）": {
      name: "ガーバーデータ 又はCADLUS Xデータ（.comp形式）",
      value: "2042500000",
    },
    DXFデータ: {
      name: "DXFデータ",
      value: "2042500001",
    },
  },
  設計CAD: {
    指定なし: {
      name: "指定なし",
      value: "2047500000",
    },
    Allegro: {
      name: "Allegro",
      value: "2047500001",
    },
    "Altium Designer（Protel）": {
      name: "Altium Designer（Protel）",
      value: "2047500002",
    },
    "CADLUS X": {
      name: "CADLUS X",
      value: "2047500003",
    },
    "CADLUS One": {
      name: "CADLUS One",
      value: "2047500017",
    },
    CADVANCE: {
      name: "CADVANCE",
      value: "2047500004",
    },
    "CR-5000": {
      name: "CR-5000",
      value: "2047500005",
    },
    "DESIGNSPARK PCB": {
      name: "DESIGNSPARK PCB",
      value: "2047500006",
    },
    Eagle: {
      name: "Eagle",
      value: "2047500007",
    },
    K2CAD: {
      name: "K2CAD",
      value: "2047500008",
    },
    K4: {
      name: "K4",
      value: "2047500009",
    },
    KiCAD: {
      name: "KiCad",
      value: "2047500019",
    },
    Mentor: {
      name: "Mentor",
      value: "2047500010",
    },
    "MY-PCB": {
      name: "MY-PCB",
      value: "2047500011",
    },
    OrCAD: {
      name: "OrCAD",
      value: "2047500012",
    },
    PADS: {
      name: "PADS",
      value: "2047500013",
    },
    PCBE: {
      name: "PCBE",
      value: "2047500014",
    },
    Quadcept: {
      name: "Quadcept",
      value: "2047500018",
    },
    "WIN PCB": {
      name: "WIN PCB",
      value: "2047500015",
    },
    その他: {
      name: "その他",
      value: "2047500016",
    },
  },
  製造工場: {
    指定なし: {
      name: "指定なし",
      value: "",
    },
    韓国: {
      name: "韓国",
      value: "104",
    },
    台湾: {
      name: "台湾",
      value: "105",
    },
    "日本(リジッド)": {
      name: "日本",
      value: "125",
    },
    "日本(フレキシブル)": {
      name: "日本",
      value: "136",
    },
  },
  リジッドフレキ基板: {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  ワイヤーボンディング: {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  "AWデータ支給設計（CAD／LIB必須）": {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  面付け: {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  "DDR I／F・EMC設計（伝送線路シミュレーション等）": {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  納期短縮対応: {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
  DXFデータ出力: {
    なし: {
      name: "なし",
      value: "0",
    },
    あり: {
      name: "あり",
      value: "1",
    },
  },
} as const

export default ESTIMATE_CONSTANT
